var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6671 1.79883V9.45161L2.17405 13.9933C1.58377 13.2919 1.54905 12.2294 2.20877 11.0419L4.37543 7.14605L6.4171 3.47244C7.03516 2.36133 7.84766 1.79883 8.6671 1.79883Z",
    fill: "#FFCB89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.1599 13.9928C14.7086 14.5415 13.9238 14.8678 12.8752 14.8678H4.45855C3.40994 14.8678 2.62522 14.5415 2.17383 13.9928L8.66689 9.45117L15.1599 13.9928Z",
    fill: "#FFCB89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.161 13.9933L8.66797 9.45161V1.79883C9.48741 1.79883 10.2999 2.36133 10.918 3.47244L12.9596 7.14605L15.1263 11.0419C15.786 12.2294 15.7513 13.2919 15.161 13.9933Z",
    fill: "#2ED173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLogo);
export default __webpack_public_path__ + "static/media/BankLogo.eb5235da5399ddbcf1175a3da49a779e.svg";
export { ForwardRef as ReactComponent };